module.exports = __webpack_public_path__ + "media/images/emblems/Kleinluetzel-blason-fcbf882ab734a261180e6b22f8351156.png";